import type { Notification } from '../../contexts/NotificationContext';

/** Ungelesen zuerst, dann gelesen — je Gruppe neueste zuerst (created_at desc). */
export function partitionNotifications(items: Notification[]): {
  unread: Notification[];
  read: Notification[];
} {
  const sorted = [...items].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
  );
  return {
    unread: sorted.filter((n) => !n.gelesen),
    read: sorted.filter((n) => n.gelesen),
  };
}

/** Relativzeit der Meldungen (Handoff Pille): „jetzt“ | „vor 5 Min.“ | „vor 3 Std.“ | „vor 4 T.“ */
export function formatRelativeShort(at: string | number, now: number = Date.now()): string {
  const ts = typeof at === 'number' ? at : new Date(at).getTime();
  const diffMin = Math.floor((now - ts) / 60000);
  if (diffMin < 1) return 'jetzt';
  if (diffMin < 60) return `vor ${diffMin} Min.`;
  if (diffMin < 1440) return `vor ${Math.round(diffMin / 60)} Std.`;
  return `vor ${Math.floor(diffMin / 1440)} T.`;
}
